<template>
  <div class="user-page">
    <h1 class="home__title">Настройки приложения</h1>
    <div class="app-settings">
      <br />
      <!--      <div class="message">-->
      <!--        Этот раздел находится в разработке. Но скоро здесь появятся удивительно полезные опции.-->
      <!--      </div>-->
      <!--      <br>-->
      <!--      <h1>🎁</h1>-->

      <div class="form__checkbox checkbox">
        <label class="checkbox__label">
          <input
            :checked="openInWindowValue"
            class="checkbox__input"
            name="target_link"
            type="checkbox"
            @click="openInWondow"
          />
          <span class="checkbox__icon">
            <svg class="icon-checkbox" width="18" height="18">
              <use xlink:href="#checkbox" />
            </svg>
            <svg class="icon-checkbox_checked" width="18" height="18">
              <use xlink:href="#checkbox-checked" />
            </svg>
          </span>
          <span class="checkbox__text">
            Открывать документы в новой вкладке (поиск, на контроле, избранное,
            недавно открытые)</span
          >
        </label>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: 'Настройки приложения'
  },
  computed: {
    openInWindowValue() {
      return this.$store.getters.getOpenInWindow;
    }
  },
  methods: {
    openInWondow(e) {
      console.log(e.target.checked);
      this.$store.dispatch('setOpenInWindowAction', e.target.checked);
    }
  }
};
</script>

<style src="./styles/index.css" />
